import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getRouteMetadata } from '../utils/routeManifest';

const setMeta = (attribute, key, content) => {
  let tag = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

export const PageMetadata = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const metadata = getRouteMetadata(pathname);
    document.title = metadata.title;
    const descriptions = [...document.head.querySelectorAll('meta[name="description"]')];
    const description = descriptions.shift() || document.createElement('meta');
    description.name = 'description';
    description.content = metadata.description;
    description.dataset.testid = 'page-meta-description';
    if (!description.parentNode) document.head.appendChild(description);
    descriptions.forEach((duplicate) => duplicate.remove());

    const canonicals = [...document.head.querySelectorAll('link[rel="canonical"]')];
    if (metadata.noindex) {
      canonicals.forEach((tag) => tag.remove());
      ['og:title', 'og:description', 'og:url', 'og:image', 'og:type']
        .forEach((key) => document.head.querySelector(`meta[property="${key}"]`)?.remove());
    } else {
      const canonical = canonicals.shift() || document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = metadata.canonical;
      canonical.dataset.testid = 'page-canonical';
      if (!canonical.parentNode) document.head.appendChild(canonical);
      canonicals.forEach((duplicate) => duplicate.remove());

      setMeta('property', 'og:title', metadata.title);
      setMeta('property', 'og:description', metadata.description);
      setMeta('property', 'og:url', metadata.canonical);
      setMeta('property', 'og:image', metadata.image);
      setMeta('property', 'og:type', metadata.type);
    }

    let robots = document.head.querySelector('meta[name="robots"]');
    if (metadata.noindex) {
      robots ||= document.createElement('meta');
      robots.name = 'robots';
      robots.content = 'noindex, follow';
      if (!robots.parentNode) document.head.appendChild(robots);
    } else {
      robots?.remove();
    }
  }, [pathname]);

  return null;
};
